isSyncSSR